import { get } from 'lodash';
import styled from 'styled-components';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import SelectAddress from 'hb-react/shared/apps/Events/components/EventRegistrationContainer/components/Form/SelectAddress';
import { useRegistrationFlowContext } from 'hb-react/shared/apps/Events/contexts/RegistrationFlowContext';
import { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import {
  Checkbox,
  Select,
  Text,
} from 'hb-react/shared/components/formik/components/inputs';

import { BillingBlock, CardHeader, StyledCol } from '../Layout';
import ShippingAddressForm from '../ShippingAddress';

const BillingAndShippingAddress = ({
  userFieldsConfig,
  setFieldValue,
  values,
}) => {
  const { currentUser } = useDefaultAppContexts();
  const { valuesStep3, isShippable } = useRegistrationFlowContext();

  const getPostalPlaceholder = (addressType, field) =>
    get(userFieldsConfig, `postal_${addressType}_${field}_placeholder`);

  return (
    <BillingBlock>
      <CardHeader>{s__('NetworkEvents|Billing address')}</CardHeader>
      <Row>
        <WrapperAdress>
          <SelectAddress
            currentUser={currentUser}
            setSelectedAddress={(addressSchema) =>
              setFieldValue(
                'receipt[billing_address_attributes]',
                addressSchema,
              )
            }
            values={valuesStep3}
          />
        </WrapperAdress>
      </Row>
      <Row>
        <StyledCol>
          <Text
            name="receipt[billing_address_attributes][address_1]"
            label={I18n.t(
              'web.networks.events.receipt.billing_location.address_1',
            )}
            placeholder={
              getPostalPlaceholder(values.receipt.address_type, 'address_1') ||
              I18n.t('web.networks.events.receipt.billing_location.address_1')
            }
            validate={{ required: true }}
          />
        </StyledCol>
        <StyledCol>
          <Text
            name="receipt[billing_address_attributes][address_2]"
            label={I18n.t(
              'web.networks.events.receipt.billing_location.address_2',
            )}
            placeholder={
              getPostalPlaceholder(values.receipt.address_type, 'address_2') ||
              I18n.t('web.networks.events.receipt.billing_location.address_2')
            }
          />
        </StyledCol>
      </Row>
      <Row>
        <StyledCol>
          <Text
            name="receipt[billing_address_attributes][address_3]"
            label={I18n.t(
              'web.networks.events.receipt.billing_location.address_3',
            )}
            placeholder={
              getPostalPlaceholder(values.receipt.address_type, 'address_3') ||
              I18n.t('web.networks.events.receipt.billing_location.address_3')
            }
          />
        </StyledCol>

        <StyledCol>
          <Text
            name="receipt[billing_address_attributes][city]"
            placeholder={I18n.t(
              'web.networks.events.receipt.billing_location.city',
            )}
            label={I18n.t('web.networks.events.receipt.billing_location.city')}
            validate={{ required: true }}
          />
        </StyledCol>
      </Row>
      <Row>
        <StyledCol>
          <Text
            name="receipt[billing_address_attributes][state]"
            placeholder={I18n.t(
              'web.networks.events.receipt.billing_location.state',
            )}
            label={I18n.t('web.networks.events.receipt.billing_location.state')}
          />
        </StyledCol>
        <StyledCol>
          <Text
            name="receipt[billing_address_attributes][postal_code]"
            placeholder={I18n.t(
              'web.networks.events.receipt.billing_location.postal_code',
            )}
            label={I18n.t(
              'web.networks.events.receipt.billing_location.postal_code',
            )}
            validate={{ required: true }}
          />
        </StyledCol>
      </Row>

      <Row>
        <StyledCol>
          <Select
            type="countries"
            name="receipt[billing_address_attributes][country]"
            placeholder={I18n.t(
              'web.networks.events.receipt.billing_location.country',
            )}
            label={I18n.t(
              'web.networks.events.receipt.billing_location.country',
            )}
            inputHtml={{
              maxMenuHeight: 160,
            }}
            validate={{ required: true }}
          />
        </StyledCol>
      </Row>

      {isShippable && (
        <>
          <Row>
            <WrapperAdress>
              <Checkbox
                name="receipt[shipping_address_attributes][same_as_billing]"
                label={s__(
                  'NetworkEvents|Billing address is same as shipping address',
                )}
              />
            </WrapperAdress>
          </Row>

          {!values.receipt?.shipping_address_attributes?.same_as_billing && (
            <ShippingAddressForm />
          )}
        </>
      )}
    </BillingBlock>
  );
};

export default BillingAndShippingAddress;

const WrapperAdress = styled(Col).attrs({ pt: 0, pb: 6 })`
  @media (min-width: 768px) {
    & > div > div {
      max-width: 536px;
      margin-bottom: 0 !important;
    }
  }
`;
